import { useFormContext } from "react-hook-form"
import cx from "classnames"

import CheckmarkCircle from "@/common/partials/checkmarkCircle"

const RadioButton = ({
  name,
  title,
  value,
  isSelected,
  isDisabled,
  rules = {},
  id = name + "-" + value,
  isSmall
}) => {
  const { register, watch } = useFormContext()

  let watchSelected

  if (isSelected === undefined) {
    const watchName = watch(name?.toString())
    watchSelected = value?.toString() === watchName?.toString()
  }

  const wrapperClassNames = cx(
    "flex items-center overflow-hidden rounded border border-black-100/25 even:mb-2 odd:rounded-b-none even:rounded-t-none sm:even:mb-0 sm:even:rounded-l-none sm:odd:rounded-r-none sm:even:rounded-r sm:odd:rounded-l",
    {
      "bg-green-10 z-10 border-green-100": isSelected || watchSelected,
      "odd:border-b-0 even:border-t-0 sm:odd:border-b sm:even:border-t sm:odd:border-r-0 sm:even:border-l-0":
        !(isSelected || watchSelected)
    }
  )

  const labelClassNames = cx(
    "relative flex items-center justify-center w-full px-4 py-3 font-bold cursor-pointer bg-white text-center h-full hover:underline",
    {
      "bg-green-10 z-10 border-green-100": isSelected || watchSelected,
      "px-3 py-2 text-base": isSmall
    }
  )

  return (
    <div className={wrapperClassNames}>
      <input
        {...register(name?.toString(), rules)}
        type="radio"
        className="absolute opacity-0 -z-1"
        defaultValue={value?.toString()}
        id={id}
        disabled={isDisabled}
      />
      <label htmlFor={id} className={labelClassNames}>
        <CheckmarkCircle selected={isSelected || watchSelected} />
        {title}
      </label>
    </div>
  )
}

export default RadioButton
